import api from "../../axios";

export const uploadLogo = async (iUserId, iLogoData) => {
  const aResponse = await api.post(`/users/${iUserId}/logo`, iLogoData, {
    timeout: 10 * 60 * 1000,
  });
  return aResponse.data;
};
